import { jsx as a, jsxs as c, Fragment as l } from "react/jsx-runtime";
import { Upload as n } from "antd";
import { R as o } from "../../../../InboxOutlined-rrW4rM7l.js";
const { Dragger: s } = n, p = ({ uploadProps: e, children: t }) => {
  const { accept: r } = e;
  return /* @__PURE__ */ a("div", { className: "at-size-full at-max-h-[30rem]", children: /* @__PURE__ */ a(s, { ...e, children: t || /* @__PURE__ */ c(l, { children: [
    /* @__PURE__ */ a("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ a(o, {}) }),
    /* @__PURE__ */ a("p", { className: "ant-upload-text", children: "點擊或拖曳文件到這裡上傳" }),
    r ? /* @__PURE__ */ c("p", { className: "ant-upload-hint", children: [
      "僅支持 ",
      r,
      " 類型檔案"
    ] }) : ""
  ] }) }) });
};
export {
  p as default
};
